<template lang="pug">
v-row(v-if="showControls")
  v-col.pb-1(cols="12")
    MenuBar(
      :editor="editor",
      v-if="editor",
      :inline="inline"
    )
  v-col.pt-1(cols="12")
    CoreWysiwyg(:value="value" :placeholder="placeholder" :inline="inline" :extensions="basicExtensions" @editorReady="onEditorReady" @input="onInput")
CoreWysiwyg(v-else :value="value" :placeholder="placeholder" :inline="inline" :extensions="basicExtensions"  @editorReady="onEditorReady", @input="onInput")
</template>

<script lang="ts">
import Vue, { getCurrentInstance } from "vue"
import { EditorContent } from "@tiptap/vue-2"
import { Editor } from "@tiptap/core"
import { PropType, ref } from "vue"
import MenuBar from "./menu/MenuBar.vue"
import { SuggestionFunction } from "components/Wysiwyg/extensions/suus-mention/suus-mention.config"
import CoreWysiwyg from "components/Wysiwyg/CoreWysiwyg.vue"
import { useBasicExtensions } from "components/Wysiwyg/useWysiwygEditor"

export default Vue.extend({
  components: {
    CoreWysiwyg,
    EditorContent,
    MenuBar,
  },
  props: {
    value: { type: String, default: "" },
    getMentionables: {
      type: Function as PropType<SuggestionFunction>,
      default: (_) => [],
    },
    showControls: { type: Boolean, default: true },
    placeholder: { type: String, default: "" },
    inline: { type: Boolean, default: false }, // note that this prop is not reactive, because it is set during mount
  },
  setup(props, { emit }) {
    const editor = ref<Editor | null>(null)
    const onEditorReady = (_editor: Editor) => {
      editor.value = _editor
    }

    const basicExtensions = useBasicExtensions(
      getCurrentInstance().proxy,
      props.getMentionables
    )

    const onInput = (val: string) => {
      emit("input", val)
    }

    return {
      editor,
      onEditorReady,
      basicExtensions,
      onInput,
    }
  },
})
</script>
